import $ from 'jquery';

var $map = document.querySelector('#cantons-map');
var $contacts = document.querySelector('.contacts ol');

// Get element position
var getPosition = el => el.getBoundingClientRect();

// Set floating address position
var setAddressPosition = (id) => {
	// HTML content of the corresponding contact
	let addressHtml = $contacts.childNodes[id].innerHTML;

	// Viewport position of the clicked canton number
	let $numbers = $('#numbers').children();
	let targetNum = $numbers.filter((index) => {
		return $numbers[index].textContent == id + 1;
	})

	let targetNumPos = getPosition(targetNum[0]);

	// Viewport position of the Cantons svg image
	let svgImagePos = getPosition(document.getElementById('cantons-map'));

	// Address-float div
	let addressFloat = document.querySelector('.address-float');

	// Absolute position values for the address-float div
	let addressFloatTop = targetNumPos.top - svgImagePos.top;
	let addressFloatLeft = targetNumPos.left - svgImagePos.left;

	let topOffset = window.innerWidth < 1200 ? 70 : 0;
	let leftOffset = window.innerWidth < 1400 ? window.innerWidth < 1200 ? 0 : 120 : 285;

	addressFloat.classList.remove('show');

	setTimeout(() => {
		addressFloat.innerHTML = addressHtml;
		addressFloat.style.top = addressFloatTop + topOffset + 'px';
		addressFloat.style.left = addressFloatLeft + leftOffset + 'px';
		addressFloat.classList.add('show');
	}, 200)
}

// Hide address-float box
var hideAddressBox = () => {
	$('.dot').removeClass('active');
	$('.canton').removeClass('active');
	$('.address-float').removeClass('show');
}

$('.canton').on('mouseenter', (e) => {
	// Add class active on clicked path
	$('.dot').removeClass('active');
	$('.canton').removeClass('active');
	$(e.target).addClass('active');

	// ID of the clicked canton taken from the canton class name
	let cantonId = e.target.parentNode.id;
	let contactId = cantonId.slice(cantonId.indexOf('_') + 1) - 1;
	
	// Add class active to dots of the clicked canton
	$(e.target).siblings().addClass('active');

	setAddressPosition(contactId);
});

$('.canton').on('mouseleave', (e) => {
	hideAddressBox();
});


if ($map) {
	// Hide address-float div on click outside the Svg image
	$('.address-float').on('click', () => hideAddressBox());

	// Hide address-float div on window load / resize
	$(window).on('load resize', () => hideAddressBox());
}

